<template>
    <v-container>
        <v-card>
            <v-card-title>
                <h3>Image Search</h3>
            </v-card-title>
            <v-responsive>
                <div class="col-md-4">
                    <!--                <v-autocomplete-->
                    <!--                        v-model="model"-->
                    <!--                        :items="items"-->
                    <!--                        :loading="isLoading"-->
                    <!--                        :search-input.sync="search"-->
                    <!--                        hide-no-data-->
                    <!--                        hide-selected-->
                    <!--                        item-text="openid"-->
                    <!--                        item-value="id"-->
                    <!--                        label="Search User"-->
                    <!--                        placeholder="Start typing to Search"-->
                    <!--                        prepend-icon="mdi-database-search"-->
                    <!--                        return-object-->
                    <!--                ></v-autocomplete>-->
                    <label for="user_id">Enter Image Code</label>
                    <input class="form-control" v-debounce:2s="getImage" id="user_id" type="text" v-model="model" color="green"/>
                    <v-label v-if="images">Total Images: {{ images.length }}</v-label>
                    <v-label v-else>No image with following code</v-label>

                </div>
                <v-flex  class="row col-md-12">

                </v-flex>
                <div style="min-height: 300px">
                    <v-flex xs12 sm6>


                        <v-card v-if="images">
                            <v-container
                                    fluid
                                    grid-list-md
                            >
                                <v-layout row wrap>
                                    <v-flex
                                            v-for="(image, index) in images"
                                            v-bind:key="index"
                                    >
                                        <v-card>
                                            <v-img
                                                    :src="image.img_url"
                                                    height="200px"
                                                    lazy-src="https://via.placeholder.com/200"
                                            >

                                            </v-img>
                                            <v-card-actions>
                                                <v-container
                                                        fill-height
                                                        fluid
                                                        pa-2
                                                >
                                                    <v-layout fill-height>
                                                        <v-flex xs12 align-end flexbox>
                                                            <span class="headline" v-text="image.result"></span>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-container>
                                            </v-card-actions>

                                        </v-card>

                                    </v-flex>

                                </v-layout>
                            </v-container>
                        </v-card>
                    </v-flex>

                </div>

            </v-responsive>
            <v-fab-transition>
                <v-btn
                        :disabled="disabled"
                        @click="dialog = !dialog"
                        dark
                        round
                        absolute
                        right
                        top
                        fab
                >
                    <v-icon>add</v-icon>
                </v-btn>
            </v-fab-transition>
        </v-card>
        <v-dialog v-model="dialog" persistent max-width="600px">

            <v-card>
                <v-card-title>
                    <span class="headline">User Profile</span>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>



                        </v-layout>
                    </v-container>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="dialog = false">Close</v-btn>
                    <v-btn color="blue darken-1" flat @click="updateProfile">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="progressDialog"
                hide-overlay
                persistent
                width="300"
        >
            <v-card
                    color="primary"
                    dark
            >
                <v-card-text>
                    Loading Data
                    <v-progress-linear
                            indeterminate
                            color="white"
                            class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>
+
<script>
    import { getOpenIds, getImages, updateProfile } from "../api/routes";

    export default {
        name: "UserSearchByCode",
        data() {
            return {
                descriptionLimit: 60,
                entries: [],
                disabled: true,
                dialog: false,
                isLoading: false,
                model: "",
                search: null,
                items: [],
                images: null,
                progressDialog: false
            }
        },
        computed: {

        },

        methods: {

            updateProfile(){
                let profile = {
                    comment: this.comment,
                    tag: this.tag,
                    open_id: this.model
                }
                this.progressDialog = true;
                updateProfile(profile)
                    .then(resp => {
                        this.dialog = false;
                        this.progressDialog = false;
                        this.getImage()
                    }).catch(error => {
                    this.dialog = false;
                })


            },
            getImage() {
                this.progressDialog = true;
                this.images = null;

                getImages(this.model, 'tag_code_number')
                    .then(resp => resp.data)
                    .then(resp => {
                        if (resp.data.length <= 0)
                            return;
                        this.images = resp.data;

                        console.log('data', resp.data)

                        this.tag = resp.data[0].tag;
                        this.comment = resp.data[0].comment;
                        this.disabled = false;
                        console.log(resp.data)
                    }).catch(error => {
                    console.log(error)
                }).finally(final => {
                    this.progressDialog = false;
                })
            }
        },

        watch: {

            search (val) {

                console.log(val, val.length)
                if (val.length < 5)
                    return;


                this.isLoading = true

                // Lazily load input items

                getOpenIds(val)
                    .then(resp => {
                        this.items = resp.data.data;
                        console.log(resp)

                    }).catch(error => {
                    console.log(error)
                })
                    .finally(final => {
                        this.isLoading = false;

                    })
            },
        },
    }
</script>

<style scoped>

</style>
